module.exports = __webpack_public_path__ + "0e5edccb026e9132510371653fd360e9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CH.svg
// module id = uOoq
// module chunks = 0